import { render, staticRenderFns } from "./learnerhome.vue?vue&type=template&id=5bf26a28&scoped=true&"
import script from "./learnerhome.vue?vue&type=script&lang=ts&"
export * from "./learnerhome.vue?vue&type=script&lang=ts&"
import style0 from "./learnerhome.vue?vue&type=style&index=0&id=5bf26a28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf26a28",
  null
  
)

export default component.exports